/* JASER — Animaciones (IntersectionObserver, JS nativo)
   - Ocultar/mostrar via .is-visible
   - Stagger via data-jaser-delay="ms" o contenedor .jaser-stagger
   - Degrada sin JS (nada queda oculto) y con prefers-reduced-motion
*/
(function () {
  'use strict';

  var REDUCED =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  var SELECTOR = [
    '.jaser-reveal',
    '.jaser-reveal-up',
    '.jaser-reveal-down',
    '.jaser-reveal-left',
    '.jaser-reveal-right',
    '.jaser-reveal-scale'
  ].join(',');

  var DEFAULT_STEP = 90;
  var MAX_DELAY = 720;

  function isReduced() {
    return !!(REDUCED && REDUCED.matches);
  }

  function addGate() {
    document.documentElement.classList.add('jaser-anim');
  }

  function delayFor(el) {
    var explicit = el.getAttribute('data-jaser-delay');
    if (explicit !== null && explicit !== '') {
      var v = parseInt(explicit, 10);
      if (!isNaN(v)) return Math.max(0, v);
    }

    var parent = el.closest ? el.closest('.jaser-stagger') : null;
    if (parent) {
      var stepRaw = parent.getAttribute('data-jaser-stagger-step');
      var step = stepRaw ? parseInt(stepRaw, 10) : DEFAULT_STEP;
      if (isNaN(step)) step = DEFAULT_STEP;
      var kids = parent.querySelectorAll(SELECTOR);
      var idx = Array.prototype.indexOf.call(kids, el);
      if (idx > 0) return Math.min(idx * step, MAX_DELAY);
    }

    return 0;
  }

  function show(el, immediate) {
    if (el.classList.contains('is-visible')) return;
    var d = immediate ? 0 : delayFor(el);
    if (d > 0) el.style.transitionDelay = d + 'ms';
    el.classList.add('is-visible');
  }

  var observer = null;

  function startObserver() {
    if (observer) return;
    observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) show(entries[i].target, false);
          if (entries[i].isIntersecting) observer.unobserve(entries[i].target);
        }
      },
      {
        rootMargin: '0px 0px -8% 0px',
        threshold: [0, 0.15]
      }
    );
  }

  function observe(root) {
    root = root || document;

    var targets = root.querySelectorAll
      ? root.querySelectorAll(SELECTOR)
      : [];

    if (isReduced() || typeof IntersectionObserver === 'undefined') {
      for (var i = 0; i < targets.length; i++) show(targets[i], true);
      return;
    }

    for (var k = 0; k < targets.length; k++) {
      if (targets[k].classList.contains('is-visible')) continue;
      observer.observe(targets[k]);
    }
  }

  function init() {
    addGate();
    startObserver();
    observe(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) observe(e.target);
  });

  document.addEventListener('shopify:section:reload', function (e) {
    if (e.target) observe(e.target);
  });

  if (REDUCED && REDUCED.addEventListener) {
    REDUCED.addEventListener('change', function () {
      if (isReduced()) {
        var all = document.querySelectorAll(SELECTOR);
        for (var i = 0; i < all.length; i++) show(all[i], true);
      }
    });
  }

  window.JaserAnimate = {
    observe: observe,
    refresh: function () {
      observe(document);
    },
    version: '1.0.0'
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
